import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/authConfig";
import App from "./App";
import { initI18n } from "@eaigle/i18n";
import "./index.css";
import { authService } from "@eaigle/api/authService";

const msalInstance = new PublicClientApplication(msalConfig);

// Share the same MSAL instance with authService so that MsalProvider and
// authService operate on the same in-memory state (active account, cache, etc.).
// Without this, two separate PCA instances compete on localStorage and
// acquireTokenSilent fails on the first load after a login redirect.
authService.configure(
  msalInstance,
  msalConfig,
  typeof import.meta.env.VITE_API_OAUTH_SCOPE === "string" ?
    import.meta.env.VITE_API_OAUTH_SCOPE
  : "",
);

void (async () => {
  try {
    await initI18n();
  } catch (err) {
    console.error("Failed to initialize i18n!", err);
  }

  const rootDiv = document.getElementById("root")!;
  ReactDOM.createRoot(rootDiv).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </React.StrictMode>,
  );
})();
